'use strict';

import React from 'react';
import { useState } from 'react';

import { Button, Form, Stack, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Alert from '../helper/Alert';

// schema for form validation
const schema = yup.object().shape({});

function PublicSearch() {
    const [message, setMessage] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [count, setCount] = useState(false);

    const { request } = useRequest();

    const search = async (values) => {
        setMessage(false);
        setCount(false);
        if (values.plz.length != 5) {
            return setMessage("Sie müssen eine Postleitzahl angeben.");
        }
        
        try {
            setDisabled(true);
            let result = await request('/Login/PublicSearch', values);
            let json = result.data;
            setDisabled(false);
            if (json.r == 1) {
                setCount(json.schools);
            }
            else {
                setMessage(json.message);
            }
        }
        catch (ex) {
            setDisabled(false);
            toast.error(ex);
            return;
        }
    }

    let foundSchools = false;
    if (count !== false) {
        if (count > 0) {
            foundSchools = <div style={{display: "flex", alignItems: "center", background: "#eee", flex: "1 1 auto"}} className="p-2">In Ihrem Umkreis nehmen aktuell <strong className="mx-1">{count}</strong> Schulen teil.</div>;
        }
        else {
            foundSchools = <div style={{ display: "flex", alignItems: "center", background: "#eee", flex: "1 1 auto" }} className="p-2">In Ihrem Umkreis sind aktuell keine Schulen angemeldet.<br />Wir arbeiten ständig daran das Netzwerk zu erweitern, gerne können Sie uns auch direkt per Mail kontaktieren.</div>;
        }
    }

    return (
        <Formik
            validationSchema={schema}
            onSubmit={(values) => {
                search(values);
            }}
            initialValues={{
                plz: '',
                distance: 25
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <Row>
                        <Col xs="auto">
                            <Form.Group controlId="plz">
                                <Form.Label>Postleitzahl</Form.Label>
                                <Form.Control style={{width: "100px"}} disabled={disabled} isInvalid={errors.plz && touched.plz} type="text" placeholder="" name="plz" value={values.plz} onBlur={handleBlur} onChange={handleChange} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.plz}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group controlId="distance" autoComplete="off">
                                <Form.Label>Umkreis</Form.Label>
                                <Form.Select style={{ width: "100px" }} disabled={disabled} isInvalid={errors.distance && touched.distance} defaultValue="25" onBlur={handleBlur} onChange={handleChange} value={values.distance}>
                                    <option value="75">75 km</option>
                                    <option value="150">150 km</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.distance}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col xs="auto" className="d-flex align-items-end">
                            <Button disabled={disabled} variant="primary" type="submit">
                                {!disabled && <i className="fa-solid fa-search me-2"></i>}
                                {disabled && <i className="fa-solid fa-spinner fa-spin-pulse me-2"></i>}
                                Suchen
                            </Button>
                        </Col>
                        {message && (
                            <Col className="d-flex align-items-center">
                                {message && <Alert className="mb-0" type="error" message={message} />}
                            </Col>
                        )}
                        {foundSchools && (
                            <Col className="d-flex">
                                {foundSchools}
                            </Col>
                        )}
                    </Row>
                </Form>
            )}
        </Formik>
    );
}

export default PublicSearch;